export enum CustomFieldType {
    INPUT,
    SELECT,
    SEARCH_SELECT,
    BUTTON_GROUP,
    DATEPICKER,
    TEXTAREA,
    RADIOBUTTON_GROUP,
}
